import {API_URL, CMS_URL, THEME_COLOR} from "../constant"
import React, { useEffect, useState } from 'react';
import HeaderBack from "../layout/HeaderBack";
import { useLocalStorage } from "../useLocalStorage";
import M from "materialize-css";
import Box from '@mui/material/Box';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import { Card, CardMedia, CardContent, Divider } from "@mui/material";
import Typography from '@mui/material/Typography';
import StepLabel from '@mui/material/StepLabel';
import Select from 'react-select';
import { Link } from "react-router-dom";
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';

import toast, { Toaster } from 'react-hot-toast';
// import { Link } from "react-router-dom";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


const ForgotPassword = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [memberID, setMemberID] = useState([]);
    const [email, setEmail] = useState([]);
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);

    function reset(){

        var urlencoded = new URLSearchParams();
        urlencoded.append("email", email);
        urlencoded.append("username", memberID);

        var requestOptions = {
        method: 'POST',
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/auth/forgotpassword`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }

    async function ResetPassword(){
        setIsOpenBackdrop(true)
        let response = await reset();
        if(response.status == 200){
            toast.success(response.message);
        }else{
            toast.error(response.message);
        }
        setIsOpenBackdrop(false)
    }

    useEffect(()=>{
    },[])

    return(
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="Forgot Password" />
            <Stack
                direction="column"
                height="90vh"
                style={{backgroundColor: "white"}}
            >
                <Box
                    flexGrow="1"
                    textAlign="center"
                    mt={5}
                >
                    {/* <Box>
                        Gambar
                    </Box> */}
                    <Box>Please type yoru email and member ID below!</Box>
                    <Box width="100%" mt={5}>
                        <TextField id="outlined-basic" label="MemberID" variant="standard" value={memberID} onChange={(e)=>setMemberID(e.target.value)}/>
                    </Box>
                    <Box width="100%" mt={2}>
                        <TextField id="outlined-basic" label="Email" variant="standard" value={email} onChange={(e)=>setEmail(e.target.value)}/>
                    </Box>
                    <Box width="100%" mt={2}>
                        <Button variant="contained" style={{backgroundColor:"#ee4d2d"}} onClick={ResetPassword}>Reset</Button>
                    </Box>
                </Box>
                <Box
                    textAlign="center"
                >
                    Already have account? <Link to={'/login'}>Login</Link>
                </Box>
            </Stack>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </React.StrictMode>
    );
}


export default ForgotPassword;